import { RexelLogo } from '@components/rexelLogo/RexelLogo';
import { Box, Stack, Typography } from '@mui/material';
import { useTranslations } from '@services/hooks/translations/useTranslations';

export const ApplicationNotSupported = () => {
  const {
    translate,
    translations: {
      applicationNotSupported: { description, header },
    },
  } = useTranslations();

  return (
    <Stack
      sx={(theme) => ({
        backgroundColor: theme.palette.background.default,
        width: `100%`,
        height: `100%`,
      })}
      justifyContent="center"
      alignItems="center"
    >
      <Box
        sx={{
          position: `absolute`,
          top: 0,
          left: 0,
          marginRight: `auto`,
          marginLeft: 7,
          marginTop: 6,
        }}
      >
        <RexelLogo />
      </Box>
      <Box className="fw fh column col-1-mobile-small col-4-desktop" top="25%" position="absolute">
        <Stack spacing={2}>
          <Typography variant="h1">{translate(header)}</Typography>
          <Typography>{translate(description)}</Typography>
        </Stack>
      </Box>
    </Stack>
  );
};
